import { ApiTransaction } from "../services/api";
import { Transaction } from "../types";

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY',
  }).format(amount);
};

export const getDefaultPayer = (username: string): string => {
  if (username === 'xinxinxin') {
    return 'xin';
  } else if (username === 'yuyuyu') {
    return 'yu';
  }
  return 'xin';
};

export const generateColors = (numColors: number, baseColors: string[]): string[] => {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    colors.push(baseColors[i % baseColors.length]);
  }
  return colors;
};

// Convert API transaction to local transaction format
export const convertApiTransaction = (
  apiTransaction: ApiTransaction
): Transaction => ({
  id: apiTransaction.transaction_id,
  date: apiTransaction.date,
  description: apiTransaction.description,
  category: apiTransaction.category,
  payer: apiTransaction.payer_username,
  amount: apiTransaction.amount,
  payer_id: apiTransaction.payer_id,
  group_id: apiTransaction.group_id,
  created_at: apiTransaction.created_at,
  updated_at: apiTransaction.updated_at,
});